import type { FC } from "preact/compat";
import type { UserAvatarProps } from "./interfaces";
import cn from "classnames";

const UserAvatar: FC<UserAvatarProps> = ({
    user,
    width = "24px",
    height = "24px",
    className,
    transform,
    title,
}) => {
    const picture = user && "picture" in user ? user.picture : user?.avatar;

    return (
        <div
            title={title ?? user?.name}
            style={{
                width,
                height,
                minWidth: width,
                minHeight: height,
                transform,
            }}
            className={cn(
                "border border-white rounded-full uppercase flex items-center justify-center text-white font-bold",
                !picture && "border-gray-400 bg-gray-200",
                className,
            )}
        >
            {picture ? (
                <img
                    src={picture}
                    alt={user?.name}
                    className="object-cover w-full h-full rounded-full"
                />
            ) : (
                user?.name.charAt(0)
            )}
        </div>
    );
};

export default UserAvatar;
